export const CheckoutChildRoutes =
  [
    {
      path: '/',
      name: 'checkout',
      component: () =>
        import(/* webpackChunkName: "checkout" */ '@/modules/checkout/_components/CheckoutProcess.vue'),
    },
    {
      name: 'authorize',
      path: 'authorize',
      component: () =>
        import(/* webpackChunkName: "checkout" */ '@/modules/checkout/_components/AuthorizingPayment.vue'),
    }
  ];